import { render, staticRenderFns } from "./AddressReview.vue?vue&type=template&id=3fa7a4e4"
import script from "./AddressReview.vue?vue&type=script&lang=js"
export * from "./AddressReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports